export class EntitySearch{
    entityID : string;
    // JObject :
}